/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyattemptstotal3Inputs */

const en_dropdailyattemptstotal3 = /** @type {(inputs: Dropdailyattemptstotal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tries in total`)
};

const de_dropdailyattemptstotal3 = /** @type {(inputs: Dropdailyattemptstotal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuche gesamt`)
};

/**
* | output |
* | --- |
* | "Tries in total" |
*
* @param {Dropdailyattemptstotal3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyattemptstotal3 = /** @type {((inputs?: Dropdailyattemptstotal3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyattemptstotal3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyattemptstotal3(inputs)
	return de_dropdailyattemptstotal3(inputs)
});
export { dropdailyattemptstotal3 as "dropDailyAttemptsTotal" }